import type { SpecItemDraftRow } from "./SectionSpecForm";

export interface SectionSpecCategoryTab {
	id: number;
	label: string;
	sortOrder: number;
}

const CATEGORY_LABELS: Record<string, string> = {
	"Rad's": "Rads",
	Linear: "Linear Dims",
	LinearDims: "Linear Dims",
	"Go / No Go": "Gauges",
	Gauges: "Gauges",
	LegAngles: "Leg Angles",
	Stencil: "Stencil",
};

export const getSectionSpecCategoryTabs = (
	rows: SpecItemDraftRow[],
): SectionSpecCategoryTab[] => {
	const categories = new Map<number, SectionSpecCategoryTab>();
	for (const row of rows) {
		if (!categories.has(row.ProfileCategoryId)) {
			categories.set(row.ProfileCategoryId, {
				id: row.ProfileCategoryId,
				label: CATEGORY_LABELS[row.CategoryName] ?? row.CategoryName,
				sortOrder: row.CategorySortOrder,
			});
		}
	}
	return [...categories.values()].sort(
		(a, b) => a.sortOrder - b.sortOrder || a.id - b.id,
	);
};
